var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',[_c('v-tab',{attrs:{"to":{name: 'messageSend'}}},[_vm._v("LINE 群發")]),_c('v-tab',{attrs:{"to":{name: 'smsMessageSend'}}},[_vm._v("簡訊群發")])],1),_c('div',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }